import React from 'react';
import {Button} from 'react-bootstrap';

function TicketList({
                        tickets,
                        showArchived,
                        setShowArchived,
                        getTicketTypeLabel,
                        getTicketStatusLabel,
                        handleOpenDetailsModal,
                        handleOpenConfirmationModal
                    }) {
    return (
        <>
            <div className="flex items-center gap-2 mb-4">
                <input
                    type="checkbox"
                    id="archivedToggle"
                    checked={showArchived}
                    onChange={(e) => setShowArchived(e.target.checked)}
                />
                <label htmlFor="archivedToggle" style={{marginLeft:'5px'}}> Inclure les demandes archivées ?</label>
            </div>
            {tickets === null ? (
                <div className='kubuni-frame' style={{paddingBottom: '10px'}}>
                    Chargement des demandes en cours...
                </div>
            ) : tickets.length === 0 ? (
                <div className='kubuni-frame' style={{paddingBottom: '10px'}}>
                    Vous n'avez pas encore créé de demande
                </div>
            ) : (
                <table className="table bordered-table">
                    <thead>
                    <tr>
                        <th className='text-center'>N°</th>
                        <th className='text-center'>Type</th>
                        <th className='text-center'>Statut</th>
                        <th className='text-center'>Titre</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {tickets
                        .filter(ticket => showArchived || ticket.status !== 'ARCHIVED')
                        .map(ticket => (
                            <tr key={ticket.id}>
                                <td className='text-center'>{ticket.id}</td>
                                <td className='text-center'>{getTicketTypeLabel(ticket.ticketType)}</td>
                                <td className='text-center'>{getTicketStatusLabel(ticket.status)}</td>
                                <td className='text-center'>{ticket.subject}</td>
                                <td className='text-center'>
                                    <Button variant="primary" className="btn-sm" style={{margin: '0 5px'}}
                                            onClick={() => handleOpenDetailsModal(ticket)}>Voir</Button>
                                    {ticket.status !== 'CLOSED' && ticket.status !== 'ARCHIVED' && (
                                        <Button variant="primary" className="btn-sm" style={{margin: '0 5px'}}
                                                onClick={() => handleOpenConfirmationModal('CLOSED', ticket)}>Clôturer</Button>
                                    )}
                                    {ticket.status !== 'ARCHIVED' && (
                                        <Button variant="primary" className="btn-sm" style={{margin: '0 5px'}}
                                                onClick={() => handleOpenConfirmationModal('ARCHIVED', ticket)}>Archiver</Button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </>
    );
}

export default TicketList;